import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deposit-type-master',
  templateUrl: './deposit-type-master.component.html',
  styleUrls: ['./deposit-type-master.component.scss']
})
export class DepositTypeMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  opendepositModal(){
    document.getElementById("deposittypeModal").style.display='block'; 
  }

  closedepositModal(){
    document.getElementById("deposittypeModal").style.display='none';
  }

}
